import { Divider, Stack, Typography } from "Components/UI";

import styles from "./OrSeparator.module.css";

export default function OrSeparator({ label = "OR" }) {
    return (
        <Stack
            align="center"
            className={styles.separator}
            direction="row"
            gap={1}
            justify="center"
        >
            <Divider />
            <Typography>{label}</Typography>
            <Divider />
        </Stack>
    );
}
